/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Up_NextInputs */

const en_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In preparation`)
};

const ar_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قيد التحضير`)
};

const de_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Vorbereitung`)
};

const es_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En preparación`)
};

const fr_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En préparation`)
};

const it_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In preparazione`)
};

const ja_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備中`)
};

const ko_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`준비 중`)
};

const pt_br_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em preparação`)
};

const ru_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В процессе подготовки`)
};

const th_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังเตรียมการ`)
};

const tr_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazırlanıyor`)
};

const zh_cn_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备中`)
};

const zh_tw_up_next = /** @type {(inputs: Up_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備中`)
};

/**
* | output |
* | --- |
* | "In preparation" |
*
* @param {Up_NextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const up_next = /** @type {((inputs?: Up_NextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Up_NextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_up_next(inputs)
	if (locale === "ar") return ar_up_next(inputs)
	if (locale === "de") return de_up_next(inputs)
	if (locale === "es") return es_up_next(inputs)
	if (locale === "fr") return fr_up_next(inputs)
	if (locale === "it") return it_up_next(inputs)
	if (locale === "ja") return ja_up_next(inputs)
	if (locale === "ko") return ko_up_next(inputs)
	if (locale === "pt_br") return pt_br_up_next(inputs)
	if (locale === "ru") return ru_up_next(inputs)
	if (locale === "th") return th_up_next(inputs)
	if (locale === "tr") return tr_up_next(inputs)
	if (locale === "zh_cn") return zh_cn_up_next(inputs)
	return zh_tw_up_next(inputs)
});